<template>
  <div class="app">
    <div class="app__image">
      <ImageAmbiance v-bind:document="document" />
    </div>
    <div class="app__content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import ImageAmbiance from './components/ImageAmbiance.vue';
import store from './store/index';

export default {
  store,
  components: {
    ImageAmbiance
  },
  beforeMount() {
    document.title = `${this.document.title} - ${this.document.subtitle}`;
  },
  data() {
    return {
      document: {
        title: 'Skip-Bo',
        subtitle: 'A VueJS application by Jeroen Burgers'
      }
    };
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700|Source+Sans+Pro:700,900&display=swap');

html {
  box-sizing: border-box;
  height: 100%;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  margin: 0;
  height: 100%;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  background-color: #f2f2f2;
  color: #150b0b;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Source Sans Pro', sans-serif;
  color: #150b0b;
  text-transform: uppercase;
}

.app {
  display: flex;
  height: 100%;

  &__image {
    width: 50%;
  }

  &__content {
    width: 50%;
    overflow-y: scroll;
    padding: 35px;
  }
}
</style>
